import assign from 'lodash.assign';

export default class HpIdService {
  constructor() {}

  login(returnUrl, data = {}) {
    let body = assign({
      linkType: 'login',
      fragmentParams: true,
      locale: this.getHpIdLocale(),
      redirectUrl: returnUrl
    }, data);

    if (data.username) {
      body.rememberMe = false;
      body.userName = data.username.replace(/\+/g, '%2B');
    }

    return window.$printos.http.v1.post('aaa', 'hpid/link', body, {version: 4}).then(resp => {
      // console.log('login', resp);
      window.location.href = resp.data.loginLink;
    });
  }

  logout(returnUrl) {
    let body = {
      linkType: 'logout',
      fragmentParams: true,
      locale: this.getHpIdLocale(),
      redirectUrl: returnUrl
    };

    return window.$printos.http.v1.post('aaa', 'hpid/link', body, {version: 4}).then(resp => {
      // console.log('logout', resp);
      window.location.href = resp.data.loginLink;
    });
  }

  join(returnUrl, data = {}, createNew = false) {
    let body = assign({
      linkType: 'join',
      fragmentParams: true,
      locale: this.getHpIdLocale(),
      redirectUrl: returnUrl
    }, data);

    return window.$printos.http.v1.post('aaa', 'hpid/link', body, {version: 4}).then(resp => {
      window.location.href = createNew ? resp.data.createLink : resp.data.loginLink;
    });
  }

  getHpIdLocale() {
    const printOSLocale = window.$printos.i18n.v1.getLocale();
    if (!printOSLocale) {
      return 'en-US';
    }

    switch(printOSLocale) {
      case 'zh-HANS':
        return 'zh-CN';
      case 'ko-KO':
        return 'ko-KR';
      default:
        return printOSLocale;
    }
  }
}
